<!--
  公告走马灯: 纯 CSS 无缝横向滚动。
  旧实现用 van-notice-bar + @replay 逐条切换, 依赖文字宽度测量与可见性,
  在 tab 切换/横竖屏/iframe 内嵌首帧测宽为 0 等场景下动画会停住(用户反馈的"卡住")。
  这里把所有公告拼成一条长文本并复制两份, 用匀速 linear 动画从 0 滚到 -50% 循环,
  不依赖任何 JS 定时器/测量, 永不卡顿。
-->
<template>
  <div class="hNoticeMarquee" @click="$emit('click')" :style="{ color }">
    <div v-if="joined" class="hNoticeTrack" :style="{ animationDuration: duration + 's' }">
      <span class="hNoticeSeg">{{ joined }}</span>
      <span class="hNoticeSeg" aria-hidden="true">{{ joined }}</span>
    </div>
  </div>
</template>

<script setup>
  import { computed } from "vue";

  const props = defineProps({
    list: { type: Array, default: () => [] },
    color: { type: String, default: "" },
    // 滚动速度(px/秒), 越大越快
    speed: { type: Number, default: 45 },
  });
  defineEmits(["click"]);

  const SEP = "　　　　"; // 多条公告之间用全角空格分隔(不加符号)
  const joined = computed(() => (props.list ?? []).filter(Boolean).join(SEP));

  // 按字符数估算一份文本的像素宽, 据此换算匀速滚动时长(不做真实测量, 避免测宽失败导致动画不启动)。
  // 中文按约 15px/字, 加上段尾留白; 动画走的是一份文本的距离(translateX -50%)。
  const duration = computed(() => {
    const segWidthPx = joined.value.length * 15 + 40;
    return Math.max(8, segWidthPx / props.speed);
  });
</script>

<style scoped>
  .hNoticeMarquee {
    flex: 1;
    min-width: 0;        /* flex 容器内允许收缩, 否则长文本会把布局撑开 */
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
    font-size: 13px;     /* 比正文(14px)小 1px */
  }

  .hNoticeTrack {
    display: inline-flex;
    white-space: nowrap;
    will-change: transform;
    animation-name: hNoticeScroll;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }

  .hNoticeSeg {
    padding-right: 40px; /* 两份之间的间隔, 同时保证 -50% 处首尾无缝衔接 */
    flex-shrink: 0;
  }

  @keyframes hNoticeScroll {
    from { transform: translateX(0); }
    to   { transform: translateX(-50%); }
  }
</style>
